import { MainView } from "../../../views/find/password";

export default function Component(props) {
    return (
        <>
            <MainView />
        </>
    );
}